import { EntryHistoryTab } from './entry-history/EntryHistoryTab';
import { LanguageType } from 'types/enums';
import { useLanguage } from 'features/hooks/useLanguage';
import { useState } from 'react';
import { Header } from 'components/Header';
import { CodelistHistoryTab } from './codelist-history/CodelistHistoryTab';
import clsx from 'clsx';
import { Grid } from 'components/UI/Grid';
import { useIsCodelistEnabledForProject } from 'features/codelist/useIsCodeListEnabled';

export function HistoryPage() {
	const language = useLanguage();

	const translation = DICTIONARY[language];

	const [activeTab, setActiveTab] = useState<'entry' | 'codelist'>('entry');

	const isCodelistEnabled = useIsCodelistEnabledForProject();

	return (
		<>
			<Header.Main />
			<Header.Navigation />
			<Header.Title title={translation.title} />

			<Grid.Container>
				<div className="flex flex-col">
					{isCodelistEnabled && (
						<div className="flex gap-2 rounded-md p-2 self-start mb-4">
							<TabButton
								active={activeTab === 'entry'}
								onClick={() => setActiveTab('entry')}
							>
								{translation.entryTab}
							</TabButton>
							<TabButton
								active={activeTab === 'codelist'}
								onClick={() => setActiveTab('codelist')}
							>
								{translation.codelistTab}
							</TabButton>
						</div>
					)}

					{activeTab === 'entry' && <EntryHistoryTab />}
					{activeTab === 'codelist' && <CodelistHistoryTab />}
				</div>
			</Grid.Container>
		</>
	);
}

const TabButton = ({
	children,
	onClick,
	active
}: {
	children: React.ReactNode;
	onClick: () => void;
	active: boolean;
}) => {
	return (
		<button
			className={clsx('text-base p-2 text-gray-900 border-b-2 hover:bg-primary-500/10', {
				'border-gray-900': active,
				'border-transparent': !active
			})}
			onClick={onClick}
		>
			{children}
		</button>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'History',
		entryTab: 'Dataset',
		codelistTab: 'Codelists'
	},

	[LanguageType.Norwegian]: {
		title: 'Historikk',
		entryTab: 'Datasett',
		codelistTab: 'Kodelister'
	}
};
